<div class="scatter-chart-container">
  <main>
    <article #fs fullscreen-able [class.is-active]="isActive" style="background-color: white;">
      <div style="background-color: #ffff;">
        <icon-chart [headerConfig]="headerConfig" [iconList]="iconList" [data]="data" [pageKey]="pageKey"
          [heading]="heading" chartName="Scatterplot4Q" [config]="ScatterChartContainer" [expand]="fs"
          [fullscreen]="isFullscreen" [item]="item" (screenChanges)="fullscreenChanges($event)" 
          (showBySubs)="showBySubs($event)"></icon-chart>
      </div>
       <div>
        <loading *ngIf="isLoading"> </loading>
      </div>
      <!-- Main Content -->
      <div class="main-content" #ScatterChartContainer>
        <!-- Left Panel: Chart -->
        <div class="chart-panel">
          <mat-tab-group
           [style.display]="noData ? 'none' : ''"
            class="toggle-tabs"
            [selectedIndex]="activeTab === 'less' ? 0 : 1"
            (selectedIndexChange)="switchTab($event === 0 ? 'less' : 'more')"
          >
            <mat-tab label="Discontinued &lt; 6 fills"></mat-tab>
            <mat-tab label="Discontinued &gt; 6 fills"></mat-tab>
          </mat-tab-group>

          <!-- Legend -->
          <div class="legend-wrapper" [style.display]="noData ? 'none' : ''">
            <div class="legend-track" #legendTrack>
              <span class="legend-item" *ngFor="let tc of territoryColors; let i = index"
                [class.legend-item--dimmed]="selectedTerritories.size > 0 && !isTerritorySelected(tc.territory)"
                (click)="toggleTerritoryFilter(tc.territory)">
                <span class="legend-dot" [style.background-color]="tc.color"></span>
                <span class="legend-text">{{ tc.territory }}</span>
              </span>
            </div>
          </div>

          <!-- Chart Container -->
          <div #chartContainer style="z-index: 1;" [style.display]="noData ? 'none' : ''" class="chart-container"></div>

          <!-- No Data Message -->
          <div style="height: 300px; width: auto; display: flex; align-items: center; justify-content: center;" *ngIf="noData">
            <span class="bg-text">{{ error_name ? error_name : 'There is no data for this time period' }}</span>
          </div>

          <!-- Lasso Selection Tooltip Popup -->
          <div class="selection-tooltip" *ngIf="!isLoading && showSelectionTooltip && selectedInstitutions.length > 0"
            [ngStyle]="{'left.px': tooltipPosition.x, 'top.px': tooltipPosition.y}" cdkDrag [cdkDragDisabled]="false"  cdkDragBoundary=".is-active">

            <!-- Selected Institutions List in Tooltip -->
            <div class="selected-institutions-panel-compact">
              <div class="panel-header">
                <span class="header-col institution-col">{{showByvalue=='D'?"Territory":'Institution'}}</span>
                <span class="header-col"> {{this.activeTab =='more' ? 'Disc. Rate' : 'Early Drop-off Rate'}}</span>
                <span class="header-col">Patients</span>
                <span class="header-col">Action <mat-icon class="close-tooltip-icon" (click)="resetSelection()">close</mat-icon></span>
              </div>
              <div class="institution-rows-scroll">
                <div class="institution-row" *ngFor="let inst of selectedInstitutions; let i = index">
                  <div class="institution-info">
                    <span class="territory-indicator" [style.background-color]="getColorForTerritory(inst.territory)">
                    </span>
                    <span class="institution-name">{{ inst.name }}</span>
                  </div>
                  <span class="institution-data">{{ numbedPipe(inst.discontinuationRate) }}%</span>
                  <span class="institution-data">{{ numbedPipe(inst.totalPatients) }}</span>
                  <button class="remove-button" (click)="removeInstitution(inst)">Remove</button>
                </div>
              </div>
            </div>

            <!-- Footer with actions -->
            <div class="tooltip-footer">
              <span class="selection-count">{{ selectedInstitutions.length }} selected</span>
              <div class="footer-actions">
                <button class="action-button reset-button" (click)="resetSelection()">
                  Reset selection ✕
                </button>
                <button class="action-button primary-button" (click)="seePrescribers()">
                  Apply Filter
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Panel: Key Attention Territories -->
        <div class="key-territories-panel" *ngIf="territoriesCard && !noData" >
      <h3 class="panel-title"> {{showByvalue=='D'?"Key Attention Territories":"Key Attention Sources"}}</h3>
      
      <div class="territory-card" *ngFor="let territory of keyTerritories">
        <h4 class="territory-name">{{ territory.name }}</h4>
        
        <div class="territory-stat">
          <span class="stat-label">Total Patients</span>
          <span class="stat-value">{{ numbedPipe(territory.totalPatients) }}</span>
        </div>

        <div class="territory-stat">
          <span class="stat-label"> {{ this.activeTab =='more' ? 'Discontinuation Rate' : 'Early Drop-off Rate'}}</span>
          <span class="stat-value danger">{{ numbedPipe(territory.earlyDropOffRate) }}%</span>
        </div>
        
        <div class="progress-bar-container">
          <div 
            class="progress-bar" 
            [style.width.%]="territory.earlyDropOffRate">
          </div>
          <div class="progress-indicator"
          [style.left.%]="territory.earlyDropOffRate">
          </div>
        </div>
      </div>
    </div>
      </div>
      <!-- <div>{{selectedInstitutions|json}}</div> -->
    </article>
  </main>
</div>